import React from 'react';

import { CoachType } from '../../../graphql/types';
import { EventLabels } from '../../../utils/trackingEvents';
import { NavigationItem, NavigationWrapper } from './Navigation';

interface Props {
  coachType: CoachType;
}

export const FitNavigation: React.FC<Props> = ({ coachType }: Props) => (
  <NavigationWrapper>
    <NavigationItem
      to="/app"
      testId="NavigationHomeLink-Fit"
      eventLabel={EventLabels.Home}
      show
    >
      Home
    </NavigationItem>
    <NavigationItem
      to="/app/members"
      testId="NavigationMembersLink-Fit"
      eventLabel={EventLabels.Members}
      show={coachType !== CoachType.Dietitian}
    >
      Members
    </NavigationItem>
    <NavigationItem
      to="/app/sessions"
      testId="NavigationSessionsLink-Fit"
      eventLabel={EventLabels.SessionsTab}
    >
      Sessions
    </NavigationItem>
    <NavigationItem
      to="/app/classes"
      testId="NavigationClassesLink-Fit"
      eventLabel={EventLabels.ClassesTab}
    >
      Classes
    </NavigationItem>
    <NavigationItem
      to="/app/methodology"
      testId="NavigationMethodologyLink-Fit"
      eventLabel={EventLabels.Methodology}
    >
      Coach O - Methodology chatbot
    </NavigationItem>
  </NavigationWrapper>
);
